/**
 * 将json字符串转换成html富文本字符串
 */

/*
例子
{
   "color": "#aaaaaa",
   "tags": [{
      "action": {
         "data": {
            "target": "pikpakapp:\/\/mypikpak.com\/drive\/setting"
         },
         "type": "common\/deeplink"
      },
      "color": "#aaaaaa",
      "text": "了解更多"
   }],
   "text": "关于 [区域会员] {%}"
}
文档：http://wiki.xunlei.cn/pages/viewpage.action?pageId=117018849
*/

interface IBaseInfo {
  color?: string
  text?: string
  image?: string
}

export type TagActionType = 'common/popup' | 'payment/switch_product' | 'common/web-deeplink' | 'common/deeplink'

export interface IRichJsonString extends IBaseInfo {
  tags?: Array<
    IBaseInfo & {
      action?: {
        data: IRichJsonString & {
          target: string
          web_target?: string
        }
        type: TagActionType
      }
    }
  >
}

export interface ConvertHtmlData {
  children?: ConvertHtmlData[]
  text?: string
  type?: TagActionType
  href?: string
  color?: string
  image?: string
  popup?: string
}

export interface IErrorInfo {
  error: string
  error_description: string
  details: Array<{
    error_rich_text: IRichJsonString
  }>
}

export interface ActivityRichInfo {
  pay_guide_icon: string
  show_pay_guide_activity: 1 | 0
  pay_activity_expire_time: number
  pay_guide_activity_text?: string
  pay_guide_rich_text?: IRichJsonString
}

export function getTarget(deeplink: string) {
  if (/^https?/.test(deeplink)) return deeplink
  if (/^pikpakapp/.test(deeplink) && /action_view/.test(deeplink)) {
    const index = deeplink.indexOf('?')
    if (index === -1) return ''
    const search = deeplink.slice(index + 1)
    const searchParams = new URLSearchParams(search)
    return searchParams.get('msg') || ''
  }
  return deeplink
}

function replaceText(text?: string) {
  return text?.replace(/\n/g, '<br>').replace(/%%/g, '%') || ''
}

export function convertJsonToHtml(richJson?: IRichJsonString): ConvertHtmlData | undefined {
  if (!richJson) return
  const { color, text, tags } = richJson
  if (!text) return

  if (text.indexOf('{%}') === -1) {
    return {
      text: replaceText(text),
      color,
    }
  }

  const htmlTags: ConvertHtmlData[] = []
  tags?.forEach((tag, i) => {
    const { action } = tag
    const t = replaceText(tag.text)
    const node: ConvertHtmlData = {
      type: action?.type,
      text: t,
      color: tag.color,
    }
    switch (action?.type) {
      case 'common/deeplink':
        if (action.data.web_target) {
          node.href = getTarget(action.data.web_target)
          break
        }
        if (tags.findIndex(item => item.action?.type === 'common/web-deeplink', i) !== -1) return
        node.href = getTarget(action.data.target)
        break
      case 'common/web-deeplink':
        node.href = getTarget(action.data.target || action.data.web_target || '')
        break
      case 'common/popup':
        // eslint-disable-next-line
        const popup = convertJsonToHtml(action.data)
        Object.assign(node, {
          children: popup ? [popup] : undefined,
          image: tag.image,
        })
        break
      case 'payment/switch_product':
        break
      default:
        break
    }

    htmlTags.push(node)
  })

  const splits = text.split(/\{%\}/)
  const texts: string[] = []
  splits.forEach((t, i) => {
    t && texts.push(t)
    i < splits.length - 1 && texts.push('')
  })

  return {
    color,
    children: texts.map(t => {
      if (!t) return htmlTags.shift() as ConvertHtmlData
      return {
        text: replaceText(t),
      }
    }),
  }
}

export function getRichText(richJson?: IRichJsonString): string {
  const richData = convertJsonToHtml(richJson)
  if (richData?.text) return `<span style="color:${richData?.color}">${richData.text}</span>`
  let result = ''
  richData?.children?.forEach(child => {
    if (child.href && child.text) {
      result += `<a href="${child.href}" class="link" style="color:${child?.color}">${child.text}</a>`
    } else if (child.text) {
      result += `<span>${child.text}</span>`
    }
  })
  return `<span style="color:${richData?.color}">${result}</span>`
}

export function getRichTextFromError(data: IErrorInfo) {
  if (!data.details?.length) return data.error_description || ''
  const richInfo = data.details.find(item => !!item.error_rich_text)
  return richInfo?.error_rich_text
}
